import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonEnvironmentOverview, CommonEnvironmentTopics } from "../../CommonComponents/CommonEnvironmentViews";

export const InfrastructureEnvironmentRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.infrastructure.environment,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonEnvironmentOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonEnvironmentTopics />;
    },
};
